module.exports = __webpack_public_path__ + "img/progress_022.b33cb220.png";